import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { universalContextShape } from '../../_universal';
import { Input } from '../Form';
import checkPasswordStrength from './checkPasswordStrength';

import style from './PasswordInput.scss';
import { withUniversalContext } from '../../shared/components/Contexts';

class PasswordInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    universalContext: universalContextShape.isRequired,
  };

  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formik: PropTypes.object,
  };

  state = {
    passwordStrength: null,
  };

  onChange = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event);
    } else if (this.context.formik) {
      this.context.formik.handleChange(event);
    }
    checkPasswordStrength(event.target.value)
      .then((passwordStrength) => this.setState({ passwordStrength }))
      .catch((error) =>
        this.props.universalContext.trackError({
          error,
          properties: { component: 'PasswordInput' },
        })
      );
  };

  renderPasswordStrength() {
    const { passwordStrength } = this.state;
    if (!passwordStrength) {
      return null;
    }
    let statusText;
    switch (passwordStrength.score) {
      case 4:
        statusText = 'Strong';
        break;
      case 3:
        statusText = 'Good';
        break;
      case 2:
        statusText = 'So-so';
        break;
      default:
        statusText = 'Weak';
    }
    return (
      <div className="margin-top-sm">
        <div
          className={classNames(
            style['password-input__strength-indicator'],
            style[`password-input__strength-indicator--${passwordStrength.score}`]
          )}
        >
          <div className={style['password-input__strength-indicator-bar']} />
        </div>
        <p className="margin-top-xs font-size-xs">
          <span className="color-muted">Password Strength: </span>
          <strong>{statusText}</strong>
        </p>
      </div>
    );
  }

  render() {
    const { universalContext, ...inputProps } = this.props;
    return (
      <React.Fragment>
        <Input {...inputProps} type="password" onChange={this.onChange} />
        {this.renderPasswordStrength()}
      </React.Fragment>
    );
  }
}

export default withUniversalContext(PasswordInput);
